import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import styles from '@/styles/Home.module.css';
import { useAppContext } from '@/context/AppContext';
import StepGuide from '@/components/StepGuide/StepGuide';
import RideForm from '@/components/RideForm/RideForm';

/**
 * Home page component
 * This is the landing page of the application
 */
const HomePage: React.FC = () => {
  const { getSourceBackendUrl, apiKey } = useAppContext();
  const backendUrl = getSourceBackendUrl();
  const showStepGuide = !apiKey;
  const [rideId, setRideId] = useState<string>('');
  const [rideDetails, setRideDetails] = useState<any>(null);
  const navigate = useNavigate();
  
  const handleRideSubmit = (id: string, details?: any) => {
    setRideId(id);
    if (details) {
      setRideDetails(details);
      console.log('Vehicle ride details:', details);
    }
    // Navigation is handled in the RideForm component
  };
  
  return (
    <>
      <Helmet>
        <title>Tracking Simulator v2</title>
        <meta name="description" content="Tracking simulator for location updates" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>

      <main className={styles.main}>
        
        {/* Show step guide when API key is not set */}
        <StepGuide visible={showStepGuide} />
        
        {/* Show ride form when API key is set */}
        {!showStepGuide && (
          <>
            <RideForm visible={true} onSubmit={handleRideSubmit} />
            
            <footer className={styles.footer}>
              <p className={styles.footerText}>
                &copy; {new Date().getFullYear()} Cityflo Tracking Simulator
              </p>
            </footer>
          </>
        )}
      </main>
    </>
  );
};

export default HomePage;
